import type { AiCostDimension } from '@Application/AiCosts/AiCostDimension';

class FetchAiCostBreakdown {
	constructor(
		public readonly accountId: number,
		public readonly dimension: AiCostDimension,
		// Period and filters only: `page` and `rows` are added by `toQueryString`.
		public readonly queryParams: URLSearchParams,
		public readonly page: number,
		public readonly rows: number,
	) {
		Object.freeze(this);
	}

	/** Identifies the period and filters, never the page. */
	get queryKey(): string {
		return this.queryParams.toString();
	}

	toQueryString(): string {
		const params = new URLSearchParams(this.queryParams);
		params.set('page', String(this.page));
		params.set('rows', String(this.rows));

		return params.toString();
	}
}

export default FetchAiCostBreakdown;
